/* src/app/cart/cart-preview/tooltip-default-standard-shipping/tooltip-default-standard-shipping.component.scss */
ion-icon {
  font-size: 18px;
}
h1 {
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
}
p {
  font-size: 14px;
  font-weight: 400;
}
.container {
  padding: 15px;
}
/*# sourceMappingURL=tooltip-default-standard-shipping.component-YCWJZD34.css.map */
